import type { CustomerIntent } from 'shared/src'
import { useI18n } from 'vue-i18n'

export const NO_MATCH_INTENT_NAME = 'Output when no Intent recognized'
export const NO_MATCH_INTENT_DESCRIPTION = 'If no intent matches the caller request'
export const NO_MATCH_INTENT_OUTPUT = 'NO_INTENT_MATCH_FALLBACK'
export const DEFAULT_INTENT_OUTPUT = 'TRANSFER_TO_HUMAN_AGENT'

export const isNoMatchIntent = (intent: CustomerIntent) => intent.is_no_match === true

export const createNoMatchIntent = (): CustomerIntent => ({
  name: NO_MATCH_INTENT_NAME,
  description: NO_MATCH_INTENT_DESCRIPTION,
  training_phrases: [],
  output: NO_MATCH_INTENT_OUTPUT,
  created_at: new Date().toISOString(),
  is_no_match: true,
})

export const useDefaultIntent = () => {
  const { t } = useI18n({ useScope: 'global' })

  const createDefaultIntent = (): CustomerIntent => ({
    name: t('intent.name'),
    description: t('intent.description'),
    training_phrases: [t('intent.phrase_1'), t('intent.phrase_2'), t('intent.phrase_3')],
    output: DEFAULT_INTENT_OUTPUT,
    created_at: new Date().toISOString(),
  })

  return {
    createDefaultIntent,
    createNoMatchIntent,
  }
}
